import React from "react"
import ReactModal from "react-modal"
import PropTypes from "prop-types"
import classNames from "classnames"

import ModalHeader from "./components/ModalHeader/index"
import ModalFooter from "./components/ModalFooter/index"
import ThemeConsumer from "../ThemeConsumer"

ReactModal.setAppElement("#main")
const getParent = () => {
  return document.querySelector("#main")
}
const ModernModal = ({
  theme,
  isOpen,
  onClose,
  children,
  customModalClass,
  customOverlayClass,
  renderFooter = true,
  removeButton = false,
  centeredButton = false,
  headerVersion,
  ...props
}) => {
  const modalClass = classNames(theme.modal, customModalClass)
  const overlayClass = classNames(theme.overlay, customOverlayClass)
  return (
    <ReactModal
      isOpen={isOpen}
      onRequestClose={onClose}
      className={modalClass}
      overlayClassName={overlayClass}
      parentSelector={getParent}
    >
      <ModalHeader {...props} onClose={onClose} headerVersion={headerVersion} />
      {children}
      {renderFooter && (
        <ModalFooter
          {...props}
          removeButton={removeButton}
          centeredButton={centeredButton}
        />
      )}
    </ReactModal>
  )
}
ModernModal.propTypes = {
  theme: PropTypes.shape({
    modal: PropTypes.string,
    overlay: PropTypes.string
  }),
  customModalClass: PropTypes.string,
  customOverlayClass: PropTypes.string,
  children: PropTypes.node,
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  renderFooter: PropTypes.bool,
  removeButton: PropTypes.bool,
  centeredButton: PropTypes.bool,
  headerVersion: PropTypes.string
}
ModernModal.defaultProps = {
  isOpen: false
}
export default ThemeConsumer("UIModernModal")(ModernModal)



// WEBPACK FOOTER //
// ./src/shared/components/ModernModal/index.js